// extracted by mini-css-extract-plugin
export var container = "LightboxContent-module--container--71a8e";
export var details = "LightboxContent-module--details--5b87c";
export var hiddenContainer = "LightboxContent-module--hiddenContainer--805f4";
export var surfaceAndDimensionsContainer = "LightboxContent-module--surfaceAndDimensionsContainer--c932d";